import { render, staticRenderFns } from "./SpecialOffer.vue?vue&type=template&id=bdb80dcc&scoped=true&"
import script from "./SpecialOffer.vue?vue&type=script&lang=js&"
export * from "./SpecialOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb80dcc",
  null
  
)

export default component.exports